'use client';
import { useEffect } from 'react';

import type { FEATURE_FLAGS_ALL_VALUES } from '@/helpers/feature-flag/model/constants';

import { getFeatureFlagClientSingleton } from '@/helpers/feature-flag/model/base/Client';
import { CustomFeatureFlagProvider } from '@/helpers/feature-flag/model/custom/Provider';

type UseInitFeatureFlagsProps = {
  featureFlagsSSR?: FEATURE_FLAGS_ALL_VALUES;
};

const useInitFeatureFlags = ({ featureFlagsSSR }: UseInitFeatureFlagsProps = {}) => {
  useEffect(() => {
    const loadFeatureFlags = async () => {
      const client = getFeatureFlagClientSingleton();
      const provider = new CustomFeatureFlagProvider();

      await client.setProvider(
        provider,
        {},
        {
          featureFlagsSSR,
        },
      );
    };

    loadFeatureFlags();
  }, []);
};

export const InitFeatureFlags = ({ featureFlagsSSR }: UseInitFeatureFlagsProps = {}) => {
  useInitFeatureFlags({ featureFlagsSSR });

  return null;
};
